import * as React from 'react'

const SvgMasterCardIcon = (props) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.9053 22.4393C21.3266 23.77 19.2787 24.5733 17.0409 24.5733C12.0478 24.5733 8 20.5737 8 15.64C8 10.7063 12.0478 6.70667 17.0409 6.70667C19.2787 6.70667 21.3266 7.51 22.9053 8.84072C24.484 7.51 26.5319 6.70667 28.7697 6.70667C33.7628 6.70667 37.8106 10.7063 37.8106 15.64C37.8106 20.5737 33.7628 24.5733 28.7697 24.5733C26.5319 24.5733 24.484 23.77 22.9053 22.4393Z"
      fill="#ED0006"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.9062 22.4393C24.8502 20.8007 26.0828 18.3626 26.0828 15.64C26.0828 12.9174 24.8502 10.4793 22.9062 8.84072C24.485 7.50999 26.5329 6.70667 28.7706 6.70667C33.7638 6.70667 37.8115 10.7063 37.8115 15.64C37.8115 20.5737 33.7638 24.5733 28.7706 24.5733C26.5329 24.5733 24.485 23.77 22.9062 22.4393Z"
      fill="#F9A000"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.905 22.4393C24.8489 20.8008 26.0815 18.3627 26.0815 15.6401C26.0815 12.9175 24.8489 10.4794 22.905 8.84082C20.9611 10.4794 19.7285 12.9175 19.7285 15.6401C19.7285 18.3627 20.9611 20.8008 22.905 22.4393Z"
      fill="#FF5E00"
    />
    <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" stroke="#F2F4F7" />
  </svg>
)

export default SvgMasterCardIcon
